
    var riot = require('riot')
    //src: starling/src/tags/popover.html
riot.tag2('popover',
  '<div if="{title || closable}" class="popover_header"> <h3 if="{title}" class="popover_title" ref="title"> <raw html="{title}"></raw> </h3> <button if="{closable}" class="unstyled_button popover_close" onclick="{close}"> <svg class="popover_close_icon"> <use xlink:href="#close-icon"></use> </svg> </button> </div> <span class="popover_arrow popover_arrow--left popover_arrow--start"></span> <div ref="body" class="popover_body" onwheel="{handleScroll}"> <yield></yield> </div>',
  '',
  'class=" popover popover--{opts.position} {opts.type && \'popover--\' + opts.type} {hidden && \'popover--hidden\'} popover--{opts.size} {opts.class} " onclick="{handleClick}" onmouseleave="{handleMouseLeave}"', function(opts) {
'use strict';

var _this = this;

var _opts = opts,
    _opts$title = _opts.title,
    title = _opts$title === undefined ? '' : _opts$title,
    _opts$closable = _opts.closable,
    closable = _opts$closable === undefined ? true : _opts$closable,
    visible = _opts.visible;

Object.assign(this, { title: title, closable: closable });

this.hidden = !visible;

this.toggle = function () {
  if (_this.hidden) {
    _this.show();
  } else {
    _this.hide();
  }

  _this.trigger('toggle');
};

this.handleMouseLeave = function () {
  _this.trigger('mouseleave');
};

this.handleClick = function () {
  _this.trigger('click');
};

this.setTitle = function (title) {
  Object.assign(_this, { title: title });
  _this.update();
};

this.show = function () {
  if (opts.flashonreopen && !_this.hidden) {
    _this.root.classList.add('already-active-notification-border');
    setTimeout(function () {
      return _this.root.classList.remove('already-active-notification-border');
    }, 1000);
  } else {
    _this.root.classList.remove('popover--hidden');
    _this.hidden = false;
  }

  _this.trigger('show');
};

this.close = function (e) {
  _this.hide(e);
  _this.trigger('close');
};

this.hide = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _this.root.classList.add('popover--hidden');
  _this.hidden = true;
  _this.trigger('hide');
};

this.on('mount', function () {
  // we don't actually want a browser tooltip
  _this.root.removeAttribute('title');
});

this.handleScroll = function (event) {
  var body = _this.refs.body;

  if (body.scrollHeight > body.clientHeight) {
    event.stopPropagation();
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('popover')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/popover.html
// module id = 666
// module chunks = 0